import { FormControlLabel, Switch, withStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';

import { axiosInstance } from '../../utils/axiosInstance';
import { hasModuleAccess } from '../../utils/helpers';
import Modal from '../Modal/Modal';

const styles = {
    container: {
        marginLeft: 0,
        marginRight: 0,
    },
    label: {
        fontSize: '0.9rem',
        lineHeight: 1.5,
        color: '#595652',
    },
};

const switchLabel = ({ classes }) => {
    const [switchState, setSwitchState] = useState({
        isChecked: true,
    });

    const [modalState, setModalState] = useState({
        isModalOpen: false,
    });

    const [spinnerState, setspinnerState] = useState({
        isSpinnerActive: false,
    });
    const isSwitchVisible = hasModuleAccess('parsing');

    const getSwitchStatus = () => axiosInstance.get(`api/auto-parse-status`).then(resp => resp);

    useEffect(() => {
        if (!isSwitchVisible) {
            return;
        }

        getSwitchStatus()
            .then(response => {
                if (switchState.isChecked !== response.data.status) {
                    setSwitchState({ isChecked: response.data.status });
                }
            })
            .catch(err => {
                console.error('err', err);
            });
    }, [isSwitchVisible]);

    const handleSpinnerChange = isSpinnerOn => {
        setspinnerState({
            ...spinnerState,
            isSpinnerActive: isSpinnerOn,
        });
    };

    const handleSwitchChange = () => {
        getSwitchStatus().then(response => {
            handleSpinnerChange(true);
            const status = { status: !response.data.status };
            axiosInstance
                .post('api/auto-parse-change', status)
                .then(() => {
                    handleSpinnerChange(false);
                    setModalState({
                        isModalOpen: false,
                    });
                    setSwitchState({ isChecked: status.status });
                })
                .catch(error => {
                    console.error('post error', error);
                    handleSpinnerChange(false);
                    setModalState({
                        isModalOpen: false,
                    });
                });
        });
    };

    const modalChangeHandler = (isModalOpen = true) => {
        setModalState({
            isModalOpen,
        });
    };

    const getModalMessage = () =>
        switchState.isChecked
            ? 'Czy na pewno chcesz wyłączyć automatyczne parsowanie?'
            : 'Czy na pewno chcesz włączyć automatyczne parsowanie?';

    const handleAnswer = answer => (answer ? handleSwitchChange() : modalChangeHandler(false));

    return (
        <>
            {modalState.isModalOpen && (
                <Modal
                    isSpinnerActive={spinnerState.isSpinnerActive}
                    isModalOpen={modalState.isModalOpen}
                    handleAnswer={handleAnswer}
                    modalMessage={getModalMessage()}
                />
            )}
            {isSwitchVisible && (
                <FormControlLabel
                    labelPlacement="start"
                    control={
                        <Switch
                            checked={switchState.isChecked}
                            onChange={() => modalChangeHandler()}
                            value="checkedA"
                            color="primary"
                        />
                    }
                    label="Parsowanie automatyczne"
                    classes={{ root: classes.container, label: classes.label }}
                />
            )}
        </>
    );
};

export default withStyles(styles)(switchLabel);
